import Axios from "axios";
import { useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Switchrs from "../../../components/inputs/Switchrs";
import Loader from "../../../components/layout/Loader";

import DashboardContext from "../../../Context";
import Forminputandswitch from "./Forminputandswitch";
import FormRedioCheck from "./FormRedioCheck";

const FormGroupoption = ({ datasend, dataFromGroupOption, handelGroupOption }) => {


    const { authentication, urldashboard, handelerrors, edit } = useContext(DashboardContext);


    const [dataFech, setDataFech] = useState([])

    const [loading, setLoading] = useState(true)

    const [rediotitle, setRediotitle] = useState([]);

    const [dataInput, setDataInput] = useState([])

    const dataFeching = async () => {
        try {
            const res = await Axios.post(`${urldashboard}/groupoptiontitle/getstep`, JSON.stringify(datasend), {
                headers: {
                    "Authorization": authentication,
                    "Content-Type": "application/json; charset=utf-8 "
                }
            })

            const data = await res.data.data
            setDataFech(data)
            setLoading(false)
            const arrypush = []
            data.map(item => {
                if (item.inputType === 2) {
                    arrypush.push(item);

                }
            })
            setRediotitle(arrypush);

        } catch (error) {
            setLoading(false)
            handelerrors(error)
        }
    }

    useEffect(() => {
        dataFeching()
        return () => {

        }
    }, [datasend])

    const handelValue = (name, values) => {

        dataFech.map(item => (
            item.groupOptionItems.map(sw => {
                switch (name) {
                    case sw.id:
                        if (values) {

                            if (dataFromGroupOption.filter(item => item.optionId === name).length > 0) {

                            }
                            else {
                                handelGroupOption([...dataFromGroupOption, { optionId: name, value: typeof values !== 'boolean' ? parseInt(values) : 1 }])
                            }

                        }
                        else {
                            handelGroupOption(dataFromGroupOption.filter(item => item.optionId !== name));
                        }

                        break;

                    default:
                        break;
                }
            }

            )))

    }





    const handelRedio = (name, values) => {

        rediotitle.map(item => {

            switch (name) {

                case item.title:

                    const findada = dataFromGroupOption.filter(itemfilter => {

                        return !item.groupOptionItems.some(so => (itemfilter.optionId === so.id))
                    })

                    handelGroupOption([...findada, { optionId: values, value: 1 }]);

                    break;

                default:
                    break;
            }
        })
    }


    const handeDataInput = items => {

        if (items.status) {

            if (dataFromGroupOption.filter(item => item.optionId === items.optionId)[0]) {

                const filteritem = dataFromGroupOption.filter(item => item.optionId !== items.optionId)

                const finaly = [...filteritem, { optionId: items.optionId, value: items.value }]


                setDataInput(finaly)

                handelGroupOption([...finaly])
            }
            else {

                const data = [...dataFromGroupOption, { optionId: items.optionId, value: items.value }]


                setDataInput(data)

                handelGroupOption([...data])
            }
        }
        else {

            const filteritem = dataFromGroupOption.filter(item => item.optionId !== items.optionId)


            setDataInput(filteritem)

            handelGroupOption([...filteritem])
        }

    }

    return (
        <>
            {loading ? <Loader />
                :
                <Row>
                    {
                        dataFech.map((item, index) => (
                            <Col key={index} lg='12' md='12' sm='12' className='mb-2' style={{ padding: '10px', backgroundColor: '#fff', borderRadius: '10px' }} >
                                <hr/>
                                <h6>{item.title}</h6>
                                {
                                    item.inputType === 2 ?
                                        <FormRedioCheck arrydata={item.groupOptionItems} handelValue={handelRedio} update={dataFromGroupOption} title={item.title} />
                                        :
                                        item.inputType === 3 ?
                                            <Row className='mt-3'>
                                                {item.groupOptionItems.map((inputs, indexs) => {
                                                    return (<Col key={indexs} className='mb-3' lg='3' md='3' sm='4' xs='6' ><Switchrs name={inputs.id} label={inputs.title} checke={dataFromGroupOption ? dataFromGroupOption.filter(find => find.optionId === inputs.id)[0] ? true : false : false} handelValue={handelValue} /></Col>)
                                                })}
                                            </Row>
                                            :
                                            <Forminputandswitch arrydata={item.groupOptionItems} update={dataFromGroupOption} handeDataInput={handeDataInput} />
                                }
                                <Row className='mt-3'>

                                </Row>
                            </Col>
                        ))
                    }
                </Row>
            }
        </>
    );
}

export default FormGroupoption;
